import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, CustomInput,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectCreate from "components/Varios/SelectCreate.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardActividadesAcademicas from "components/Varios/CardActividadesAcademicas.js";

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class ActividadesAcademicasData {
    idactividadacadservicio: number = 0;
    idpersona: number = 0;

    tipoexperiencia: string = "";
    nombreempresa: string = "";
    departamento: string = "";
    cargo: string = "";
    fechadesde: string = "";
    fechahasta: string = "";
    estado: string = "A";
    idpais: number = 0;
    ingresorrhh: string = "N";
    idcatalogo: number = 0;
    strOtraActividadAcademica?: string = "";
}

interface ActividadesAcademicasDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: ActividadesAcademicasData;
    ActividadesAcademicasDataList: ActividadesAcademicasData[];
    paisList: Array<any>;
    tipoInstitucionList: Array<any>;
    OtrasActividadesAcademicasList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class ActividadesAcademicas extends React.Component<RouteComponentProps<{}>, ActividadesAcademicasDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new ActividadesAcademicasData(),
            ActividadesAcademicasDataList: [], paisList: [], tipoInstitucionList: [], OtrasActividadesAcademicasList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarActividadesAcademicas = this.cargarActividadesAcademicas.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        //this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarActividadesAcademicas();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        fetch(API_URL + "DatosExperiencia/TipoInstitucion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoInstitucionList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener los tipos de institución.")
                    }
                    else {
                        alertService.error("Ocurrió un error al obtener los tipos de institución. " + result)
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tipoInstitucionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        fetch(API_URL + "DatosEscalafon/OtrasActividadesAcademicas")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            OtrasActividadesAcademicasList: result.entTabla.map(d => ({
                                "value": d.idcatalogo,
                                "label": d.descripcion
                            })),
                        });
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener las actividades académicas.")
                    }
                    else {
                        alertService.error("Ocurrió un error al obtener las actividades académicas. " + result)
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        OtrasActividadesAcademicasList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }
    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarActividadesAcademicas() {
        fetch(API_URL + "DatosEscalafon/ActividadAcadServicioDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        //console.log(result.entTabla);
                        this.setState({
                            ActividadesAcademicasDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            //tiposEvidencia: this.cargarEvidencias(null)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener la información académica.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        ActividadesAcademicasDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    //handleFileUploadChange(tipoEvidencia, uploadFile) {
    //    const src = window.URL.createObjectURL(uploadFile);
    //    const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
    //    let fileInfoState = this.state.filesData.slice();
    //    let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
    //    fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

    //    this.setState({
    //        filesData: fileInfoState,
    //    });

    //}

    //cargarEvidencias(tipoEvidencia) {
    //    var tiposEvidencia = [{ "value": "EAC", "label": "Certificado de mención de honor" }];
    //    console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
    //    return tiposEvidencia;
    //}

    //descargarEvidencias(infoAcademica: ActividadesAcademicasData) {
    //    var evidencias = new Array();
    //    if (infoAcademica.refarchivo) {
    //        evidencias.push({ name: "EAC" + infoAcademica.idpersona + ".PDF", url: API_URL + "InformacionAcademica/Mencionhonor/Refarchivo/" + infoAcademica.idactividadacadservicio });
    //    }
    //    return evidencias;
    //}

    onClickLimpiar() {
        this.setState({ dtoData: new ActividadesAcademicasData() });
    }

    onClickEdit(idactividadacadservicio) {
        this.setState({
            dtoData: new ActividadesAcademicasData()
        });

        fetch(API_URL + "DatosEscalafon/ActividadAcadServicioById/" + idactividadacadservicio)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            dtoData: result.entTabla[0],
                            //tiposEvidencia: this.cargarEvidencias(null),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new ActividadesAcademicasData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idactividadacadservicio) {
        fetch(API_URL + "FormularioController/DeleteDatosActividadAcadServicio/" + idactividadacadservicio, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La actividad académica se eliminó correctamente.")
                        this.cargarActividadesAcademicas();
                    }
                })
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        if (dto['fechahasta'] && dto['fechadesde'] > dto['fechahasta']) {
            alertService.error("Error: La fecha de inicio debe ser menor a la fecha de fin.");
            return;
        }

        forma.forEach((value, clave) => {
            if (!value && (clave !== "evidencias" && clave !== "cargo" && clave !== "idcatalogo" && clave !== "fechahasta")) {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fechadesde' || clave === 'fechahasta') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }
        });


        delete dto['strOtraActividadAcademica'];

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idactividadacadservicio === 0) {
                fetch(API_URL + "FormularioController/PostDatosActividadAcadServicio", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La actividad se ha registrado correctamente.")

                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idactividadacadservicio', responseJson.teducacionformal.idactividadacadservicio);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosActividadesAcademicas", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => console.log(error));
                                //}
                                this.cargarActividadesAcademicas();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosActividadAcadServicio", {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La actividad se ha actualizado correctamente.")
                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idactividadacadservicio', responseJson.teducacionformal.idactividadacadservicio);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosActividadesAcademicas", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => console.log(error));
                                //}
                                this.onClickLimpiar();
                                this.cargarActividadesAcademicas();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }
    }

    public render() {
        let contents = this.state.loading || !this.state.currentUser.roles.includes("DOCENTEGRADO,")

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.ActividadesAcademicasDataList, this.state.paisList, this.state.tipoInstitucionList, this.state.OtrasActividadesAcademicasList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(ActividadesAcademicasDataList: Array<any>, paisList: Array<any>, tipoInstitucionList: Array<any>, OtrasActividadesAcademicasList: Array<any>, tiposEvidencia: Array<any>) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Actividades académicas (servicios) </h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipoexperiencia">Tipo de institución*</Label>
                                                    <SelectItem
                                                        options={tipoInstitucionList}
                                                        value={this.state.dtoData.tipoexperiencia}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipoexperiencia"
                                                        id="tipoexperiencia"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label for="nombreempresa">Empresa*</Label>
                                                    <Input maxLength="100" name="nombreempresa" id="nombreempresa" value={this.state.dtoData.nombreempresa} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="departamento">Área o departamento*</Label>
                                                    <Input maxLength="100" name="departamento" id="departamento" value={this.state.dtoData.departamento} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label for="cargo">Cargo*</Label>
                                                    {(this.state.dtoData.idcatalogo == null ?
                                                        <Input maxLength="100" name="cargo" id="cargo" value={this.state.dtoData.cargo} onChange={this.handleChange} />
                                                        :
                                                        <SelectItem
                                                            options={OtrasActividadesAcademicasList}
                                                            value={this.state.dtoData.idcatalogo}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idcatalogo"
                                                            id="otrasactividadesacademicas"
                                                            icon="fa-caret-right"
                                                        />
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fechadesde">Desde*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fechadesde}
                                                    name="fechadesde"
                                                    id="fechadesde"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fechahasta">Hasta*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fechahasta}
                                                    name="fechahasta"
                                                    id="fechahasta"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">País*</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="idpais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {ActividadesAcademicasDataList.map((dto, index) =>
                                                <CardActividadesAcademicas
                                                    key={dto.idactividadacadservicio}
                                                    objeto={dto}
                                                    number={(index + 1) + " / " + ActividadesAcademicasDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idactividadacadservicio)}
                                                    eventDelete={() => this.onClickDelete(dto.idactividadacadservicio)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default ActividadesAcademicas;